import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios'; // Assuming your baseURL is configured here

const PaymentPage = () => {
  const { testAttemptId } = useParams();
  const [paymentData, setPaymentData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const initiatePayment = async () => {
      try {
        const studentId = localStorage.getItem('id');

        // Step 1: Create Razorpay order
        const res = await axios.post('/payments/create-order', {
          studentId,
          testAttemptId
        });

        const { order, key } = res.data;

        const options = {
          key,
          amount: order.amount,
          currency: order.currency,
          name: 'Your Exam Portal',
          description: 'Test Payment',
          order_id: order.id,
          handler: async (response) => {
            try {
              // Step 2: Verify and update payment
              await axios.post('/payments/verify', {
                orderId: order.id,
                paymentId: response.razorpay_payment_id,
              });

              alert('Payment Successful!');
              navigate('/test-instructions/' + testAttemptId); // or wherever you want to go
            } catch (err) {
              alert('Payment verification failed');
            }
          },
          prefill: {
            name: 'Student',
            email: 'student@example.com',
            contact: '9999999999'
          },
          theme: {
            color: '#3399cc'
          }
        };

        const rzp = new window.Razorpay(options);
        rzp.open();

        rzp.on('payment.failed', function (response) {
          alert('Payment failed. Please try again.');
          console.error(response.error);
        });

      } catch (error) {
        console.error('Error in payment:', error);
        alert('Something went wrong during payment.');
      }
    };

    initiatePayment();
  }, [testAttemptId, navigate]);

  return (
    <div className="p-6 text-center">
      <h2 className="text-xl font-semibold">Redirecting to Razorpay...</h2>
    </div>
  );
};

export default PaymentPage;
